// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5238": "ceea25bf5d3b","6373": "11aa0e68634e","8871": "3065b536e6ec",}[chunkId] + ".css"
}